import { ChangeEvent } from 'react';
import styled from 'styled-components';
import { usePostImageSellTractorsMutation } from '../../../hooks/api/etc/upload/mutations/usePostImageSellTractors.mutation';
import { Loading } from '../loading/Loading';

interface SellTractorImageUploaderProps {
  inputId: string;
  successHandler: (fileUrl: string) => void;
  errorHandler: () => void;
}

export const SellTractorImageUploader = ({ inputId, successHandler, errorHandler }: SellTractorImageUploaderProps) => {
  const { mutate: postImageSellTractors, isLoading: isImageUploading } = usePostImageSellTractorsMutation();

  const uploadImage = async (event: ChangeEvent<HTMLInputElement>) => {
    const imageFile: File | null = event.target.files ? event.target.files[0] : null;

    const resetInputValue = () => {
      event.target.value = '';
    };

    if (imageFile) {
      postImageSellTractors(
        { reqBody: { file: imageFile } },
        {
          onSuccess: (res) => successHandler(res.url),
          onError: () => {
            errorHandler();
            resetInputValue();
          },
        },
      );
    }
  };

  return (
    <>
      <Uploader>
        <Label htmlFor={inputId} />
        <Input
          id={inputId}
          type="file"
          accept="image/*"
          onChange={(e: ChangeEvent<HTMLInputElement>) => uploadImage(e)}
        />
      </Uploader>

      <Loading loading={isImageUploading} />
    </>
  );
};

const Uploader = styled.div`
  position: absolute;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
`;

const Label = styled.label`
  width: 100%;
  height: 100%;

  display: flex;

  cursor: pointer;
`;

const Input = styled.input`
  position: absolute;

  width: 1px;
  height: 1px;

  padding: 0;

  margin: -1px;

  overflow: hidden;

  clip: rect(0, 0, 0, 0);
  border: 0;
`;
